import DesktopCollectionPanel from './DesktopCollectionPanel';
import DesktopCollectionPanelPhase2 from './DesktopCollectionPanel.actionbar_phase_2';
import DesktopCollectionPanelContainer from './DesktopCollectionPanel.container';
import { withFeatureBranch } from '../../redux/flags';
export default DesktopCollectionPanelContainer(withFeatureBranch({
    actionbar_phase_2: DesktopCollectionPanelPhase2,
})(DesktopCollectionPanel));
//# sourceMappingURL=index.js.map